import styled from 'styled-components';

export const Translation = styled.div`
  .translation {
    border: 1px solid #ededed;
    margin: 20px 24px;
    padding: 15px 20px;
    .translation-container {
      display: flex;
      gap: 60px;
      align-items: center;
      .enable-translation {
        width: 100%;
        .heading {
          font-size: 14px;
          padding-bottom: 10px;
        }
        .description {
          font-size: 12px;
          color: #7d7d7d;
        }
      }
    }
  }
  .google-translate-container {
    display: flex;
    align-items: end;
    width: 200px;
    font-size: 14px;
    color: gray;
    cursor: pointer;
    margin-top: 12px;
    filter: grayscale(0);
    gap: 2px;
  }
  .google-logo {
    bottom: 1px;
    margin-left: 3px;
  }
  .translate-key-container {
    padding-top: 30px;
    width: 80%;
    .translate-key {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
    .translate-key:nth-child(1) {
      font-size: 12px;
      color: #475867;
    }
    .translate-key-field {
      height: 45px;
    }
    .save-key {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 100px;
      margin: 20px 0px 0px;
    }
  }
`;
